import type { ConnectProto } from "@racoon/api";

export type LocationPhoto = ConnectProto.FileUpload & {
  driverFirstName?: string;
  driverLastName?: string;
};

export const flattenLocationPhotos = (
  list: ConnectProto.PickupLocationPhotoList | undefined,
): LocationPhoto[] =>
  (list?.photos ?? []).flatMap((photo) =>
    photo.fileUpload
      ? [
          {
            ...photo.fileUpload,
            driverFirstName: photo.driverFirstName,
            driverLastName: photo.driverLastName,
          },
        ]
      : [],
  );
